var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .hatch_een{fill:#fffffffffff;} .hatch_twee{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hatch_twee",
    d: "M25.481,8.796l0.707,0.707l-16.62,16.62L8.86,25.416L25.481,8.796z M24.188,7.503l-0.707-0.707 L6.86,23.416l0.707,0.707L24.188,7.503z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hatch_een",
    d: "M31.067,6.721c-0.05-0.121-0.123-0.233-0.217-0.327l-4.243-4.243c-0.188-0.188-0.442-0.293-0.707-0.293 c-0.265,0-0.52,0.105-0.707,0.293L4.686,22.657c-0.119,0.119-0.193,0.25-0.209,0.362c-0.019,0.032-1.469,5.76-1.469,5.76 c-0.085,0.341,0.015,0.701,0.263,0.95c0.19,0.19,0.445,0.293,0.707,0.293c0.081,0,5.899-1.444,5.899-1.444 c0.033-0.008,0.148-0.057,0.175-0.069c0.106-0.049,0.289-0.192,0.29-0.194L30.849,7.808c0.094-0.094,0.168-0.206,0.217-0.327 C31.166,7.237,31.166,6.964,31.067,6.721z M25.899,2.858L30.142,7.1l-2.471,2.471l-4.243-4.243L25.899,2.858z M3.979,29.021 l0.424-1.697l1.273,1.273L3.979,29.021z M6.808,28.314l-2.122-2.121l0.707-2.829l4.243,4.243L6.808,28.314z M10.343,26.899 l-4.243-4.243l16.62-16.62l4.243,4.243L10.343,26.899z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8218c2f4a8a31cfd18f023959cbaf8cc.svg";
export { ForwardRef as ReactComponent };